import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    Link, ImageInput, ImageField,
} from 'react-admin';
import {
    Grid,
    Stack
} from '@mui/material';

export const AdminAiSystemAgentToolCreate: () => JSX.Element = (): JSX.Element => {

    return (
        <>
            <Create actions={false} redirect={ 'list' }>
                <SimpleForm>
                    <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                        <Grid size={ 6 }>
                            <Stack spacing={ 2 }>
                                <TextInput label="Operator Tool ID" name="operatorToolId" source="operatorToolId" />
                                <BooleanInput name="enabled" source="enabled" />
                                <TextInput name="name" source="name"/>
                            </Stack>
                        </Grid>
                        <Grid size={ 6 }>
                            <Stack spacing={ 2 }>
                                <TextInput
                                    multiline
                                    name="description"
                                    source="description"
                                    minRows={8}
                                    helperText={"Clear description of tool functionality"}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={12}>
                            <TextInput
                                multiline
                                name="customParameters"
                                source="customParameters"
                                minRows={8}
                                helperText={"Custom Form JSON for Workflow node edit"}
                            />
                            <Link to="https://rjsf-team.github.io/react-jsonschema-form/docs/" target="_blank">JSON format reference</Link>
                        </Grid>
                        <Grid size={12}>
                            <ImageInput name="image" source="image" label="Icon" accept={{ 'image/*': ['.jpg', '.png', '.gif', '.jpeg'] }}>
                                <ImageField source="src" title="title" />
                            </ImageInput>
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Create>
        </>

    );

}